<script lang="ts">
import layout from '~/consumer/layouts/DefaultLayout.vue'
export default { layout }

</script>
<script setup lang="ts">
import SignupForm from '@consumer/modules/signup/SignupForm.vue'

const isSubmitted = ref(false)
</script>

<template>
  <GContainer class="py-10 lg:pt-20 lg:pb-44">
    <div class="flex flex-col gap-2 lg:flex-row lg:justify-between lg:items-center mb-6 lg:mb-10">
      <h1 class="text-2xl lg:text-4xl">Create Your Account</h1>
      <div v-if="!isSubmitted">
        Already have an account?
        <GButton flat href="/login" size="inherit" label="Log In"/>
      </div>
    </div>

    <GCard rounded class="border-1 border-grey-primary p-8 lg:px-10 font-medium">
      <template v-if="isSubmitted">
        <h2 class="text-xl lg:text-2xl mb-4">Please check your email.</h2>
        <p class="!mb-0 text-v2-secondary">
          We sent you an email with a verification link. Please click the link to create your account
          and access your account page.
        </p>
      </template>

      <template v-else>
        <div class="text-v2-secondary">
          Sign up for Giftly to view the gifts you send and manage payment information.
        </div>

        <GDivider class="py-4 my-2"/>

        <SignupForm @complete="isSubmitted = true"/>
      </template>
    </GCard>
  </GContainer>
</template>
